import React from "react";
import Paper from "@mui/material/Paper";
import {styled} from "@mui/material/styles";
import {s_char} from "../_signals/s_char";
import {useSignals} from "@preact/signals-react/runtime";
import updChar from "../_sig_api/updChar";

const Item = styled(Paper)(({theme}) => ({
    backgroundColor: '#fff', ...theme.typography.body2, padding: 4, height: '100%', textAlign: 'center', color: '#000',
}));


function CharNSC() {

    useSignals();

    const changeNSC = (event) => {
        updChar([{k:'nsc',v: event.target.checked}]);
    }

    return <Item>
        <label>nsc</label>
        <input
            type="checkbox"
            checked={s_char.value.nsc}
            onChange={changeNSC}
        />
    </Item>
}

export default CharNSC